import { useNavigate, useLocation } from 'react-router-dom';
import { Home, PlusCircle, Package, User } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';
import { cn } from '@/lib/utils';
import { motion } from 'framer-motion';

const tabs = {
  en: [
    { path: '/', icon: Home, label: 'Home' },
    { path: '/toy', icon: PlusCircle, label: 'Create' },
    { path: '/track', icon: Package, label: 'Orders' },
    { path: '/account', icon: User, label: 'Account' },
  ],
  fa: [
    { path: '/', icon: Home, label: 'خانه' },
    { path: '/toy', icon: PlusCircle, label: 'ساخت' },
    { path: '/track', icon: Package, label: 'سفارش‌ها' },
    { path: '/account', icon: User, label: 'حساب' },
  ],
};

export function MobileBottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { language } = useLanguage();

  const currentTabs = tabs[language] || tabs.en;

  // Hide on wizard sub-pages (they have their own navigation)
  const hideOnPrefixes = ['/toy', '/story'];
  const isWizardPage = hideOnPrefixes.some(
    (p) => location.pathname.startsWith(p) && location.pathname !== p
  );
  if (isWizardPage) return null;

  return (
    <nav
      aria-label={language === 'fa' ? 'منوی پایین' : 'Bottom navigation'}
      className="fixed bottom-0 left-0 right-0 z-50 md:hidden safe-area-bottom"
    >
      <div className="flex items-stretch border-t border-border bg-background/80 backdrop-blur-lg h-14">
        {currentTabs.map((tab) => {
          const isActive = location.pathname === tab.path;
          const Icon = tab.icon;

          return (
            <button
              key={tab.path}
              onClick={() => navigate(tab.path)}
              className={cn(
                'flex-1 flex flex-col items-center justify-center gap-0.5 transition-colors relative',
                isActive
                  ? 'text-primary'
                  : 'text-muted-foreground hover:text-foreground'
              )}
              aria-current={isActive ? 'page' : undefined}
              aria-label={tab.label}
            >
              {isActive && (
                <motion.span
                  layoutId="bottomNavIndicator"
                  className="absolute top-0 left-1/4 right-1/4 h-0.5 bg-primary rounded-full"
                  transition={{ type: 'spring', stiffness: 500, damping: 35 }}
                />
              )}
              <Icon size={20} strokeWidth={isActive ? 2.5 : 2} />
              <span className="text-[10px] font-medium leading-none">
                {tab.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
